const RightChevron = () => {
  return (
    <svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1.5 16C1.14844 16 0.835938 15.8828 0.601562 15.6484C0.09375 15.1797 0.09375 14.3594 0.601562 13.8906L5.95312 8.5L0.601562 3.14844C0.09375 2.67969 0.09375 1.85938 0.601562 1.39062C1.07031 0.882812 1.89062 0.882812 2.35938 1.39062L8.60938 7.64062C9.11719 8.10938 9.11719 8.92969 8.60938 9.39844L2.35938 15.6484C2.125 15.8828 1.8125 16 1.5 16Z" fill="#7C7C7C"></path>
    </svg>
  )
}
export default RightChevron